;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:linkedregistrations-ui":true});}catch(e){}}();export enum EventStatus {
  EventCancelled = 'EventCancelled',
  EventPostponed = 'EventPostponed',
  EventRescheduled = 'EventRescheduled',
  EventScheduled = 'EventScheduled',
}

export enum EventTypeId {
  General = 'General',
  Course = 'Course',
  Volunteering = 'Volunteering',
}

export enum PublicationStatus {
  Draft = 'draft',
  Public = 'public',
}

export enum SuperEventType {
  Recurring = 'recurring',
  Umbrella = 'umbrella',
}

export const TEST_EVENT_ID = 'helmet:222453';
export const TEST_EVENT_ID2 = 'kulke:53330';
export const TEST_EVENT_ID3 = 'kulke:53616';
export const TEST_EVENT_ID4 = 'kulke:53008';
export const TEST_EVENT_ID5 = 'kulke:50502';

export const EVENT_WITH_SUB_EVENTS_INCLUDES = ['sub_events'];
